import { Box, Button, Typography } from '@mui/material';
import SimpleDialog from '../../common-components/dialog/SimpleDialog';

interface ResponseDialogProps {
  open: boolean;
  onClose: () => void;
  headerText: string;
  titleText: string | JSX.Element;
  content: JSX.Element;
}

function ResponseDialog({
  open,
  onClose,
  headerText,
  titleText,
  content,
}: ResponseDialogProps) {
  const CONTENT_MIN_HEIGHT = 80;
  const CONTENT_MAX_HEIGHT = 500;
  const CONTENT_MAX_WIDTH = 500;

  const renderTitle = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography>{titleText}</Typography>
    </Box>
  );

  const renderActions = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        gap: 1,
        mt: 1,
      }}
    >
      <Button
        variant="contained"
        onClick={onClose}
        data-testid="response-dialog-close-button"
        sx={{ mb: 0, minWidth: '80px' }}
      >
        Close
      </Button>
    </Box>
  );

  const renderContent = () => (
    <Box
      sx={{
        minHeight: CONTENT_MIN_HEIGHT,
        maxHeight: CONTENT_MAX_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexGrow: 1,
          mt: 1,
          mb: 1,
        }}
      >
        {renderTitle()}
      </Box>
      {content || (
        <Typography>
          {`This destination's PRO report isn't available yet. More reports are being added all the time.`}
        </Typography>
      )}
    </Box>
  );

  return (
    <SimpleDialog
      onClose={onClose}
      open={open}
      title={headerText}
      width={CONTENT_MAX_WIDTH}
      actions={renderActions()}
      data-testid="pro-report-response-dialog"
    >
      {renderContent()}
    </SimpleDialog>
  );
}

export default ResponseDialog;
